import React, { useEffect } from 'react';
import AlarmCard from './AlarmCard';
import './AlarmStatusWidget.scss';
import Loader from '../common/Loader/Loader';
import { useAppDispatch, useAppSelector } from '../../hooks/storeHooks';
import { fetchAlarmsData, selectAlarms, selectAlarmsLoading, selectAlarmsError } from './WellSummaryDashboardSlice';

export default function AlarmStatusWidget() {
  const dispatch = useAppDispatch();
  const alarmData = useAppSelector(selectAlarms);
  const loading = useAppSelector(selectAlarmsLoading);
  const error = useAppSelector(selectAlarmsError);

  useEffect(() => {
    dispatch(fetchAlarmsData({}));
  }, [dispatch]);

  return (
    <div className='alarms-main-container'>
      <div className='content-wrapper'>
        <div className='header-section'>
          <div className='header-content'>
            <div className='title-wrapper'>
              <span className='title'>Active alarms</span>
            </div>
          </div>
          <div className='divider' />
        </div>
        <div className='alarms-section'>
          <div className={`alarms-container ${loading ? 'is-loading' : ''}`}>
            {error ? (
              <div className='wsw-error'>Failed to load data.</div>
            ) : loading ? (
                <div className="alarms-loader-center">
                 <Loader />
                </div>
            ) : (
              <div className='alarms-list'>
                {alarmData.map((alarm) => (
                  <AlarmCard key={alarm.mop} mop={alarm.mop} count={alarm.count} />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
